import React from 'react';
import Header from '../../common/header/header';
import Footer from '../../common/footer/footer';
import LegalDocumentBody from '../../common/legalDocumentBody/legalDocumentBody';
import agreementFile from '../../../files/Пользовательское соглашение.pdf';
import { agreementDocumentText } from '../../../data/legal/agreementText';
import classes from '../../common/legalPage/legalPage.module.css';

const AgreementPage = () => {
  return (
    <div className={classes.page}>
      <Header />
      <main className={classes.main}>
        <section className={classes.card}>
          <h1 className={classes.title}>Пользовательское соглашение</h1>
          <p className={classes.subtitle}>
            Полная версия документа размещена ниже без сокращений
          </p>

          <a
            href={agreementFile}
            download="Пользовательское соглашение.pdf"
            className={classes.download}
          >
            Скачать пользовательское соглашение (PDF)
          </a>

          <LegalDocumentBody text={agreementDocumentText} />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AgreementPage;
